import { Row, Col } from "../../App.styles";

const PointsSection = ({ useQuery }) => {
  const {
    points,
    task_type,
    trivia_points_1,
    trivia_points_2,
    trivia_points_3,
    trivia_points_4,
    trivia_points_5,
    trivia_points_unlimited,
  } = useQuery();

  const p = (points) => {
    if (parseInt(points) === 9999) {
      return "GOTO UNLIMITED SETTING";
    }

    return points;
  };

  return task_type !== 5 ? (
    <Row>
      <Col>
        <p>Default points: {points}</p>
      </Col>
    </Row>
  ) : (
    <>
      <Row>
        <Col>
          <p>Default points if correct on first guess: {p(trivia_points_1)}</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>Default points if correct on second guess: {p(trivia_points_2)}</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>Default points if correct on third guess: {p(trivia_points_3)}</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>Default points if correct on fourth guess: {p(trivia_points_4)}</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>Default points if correct on fifth guess: {p(trivia_points_5)}</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>
            Default points if correct on unlimited guessing:{" "}
            {trivia_points_unlimited === 9999
              ? "DO NOT ALLOW UNLIMITED GUESSING"
              : trivia_points_unlimited}
          </p>
        </Col>
      </Row>
    </>
  );
};

export default PointsSection;
